import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Button } from '@material-ui/core';
import { DateRange, CheckCircle } from '@material-ui/icons';
import Notification from '../../components/Notification';
import MonthCalendar from './MonthCalendar';
import DateControl from './DateControl';
import CreateScheduleModal from './CreateScheduleModal';
import DoctariCalendar from '../../components/DoctariCalendar';
import DoctariModal from '../../components/Modal';

import { appointmentActionsTypes } from '../../redux/appointment/actions';
import { userActionsTypes } from '../../redux/user/actions';
import { APPOINTMENT_LIGHT } from '../../utils/urls';
import { getSchedulesByDatesLimitDates, isProfessional } from '../../utils/helpers';
import { useStyles } from './style';
import DoctariSpinner from '../../components/Spinner';

function Agenda({
  getDoctorInfo,
  createSchedule,
  doctorsInfo,
  session,
  appointmentsData,
  getSchedulesByDateLight,
  deleteMessages,
  deleteSchedule,
  doctors,
}) {
  const history = useHistory();
  const classes = useStyles();
  // console.log('ESTE ES EL DOCTOR REDUCE EN AGENDA ', doctors.selectDoctor.id);
  const [dateHandler, setDateHandler] = useState({
    currentWeek: 0,
    currentMonth: 0,
    showByWeek: true,
  });
  const { currentWeek, currentMonth, showByWeek } = dateHandler;

  const [availability, setAvailability] = useState({
    start: null,
    end: null,
    isEditable: false,
    createModalOpen: false,
    openModalAvailability: false,
  });
  const [selectedSchedule, setSelectedSchedule] = useState({
    id: null,
    groupId: null,
    editModalOpen: false,
  });

  const { start, end, isEditable, createModalOpen, openModalAvailability } =
    availability;
  const doctorId = doctors.selectedDoctor ? doctors.selectedDoctor.id : null;

  const [isCreateAppointment, setIsCreateAppointment] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (appointmentsData.success.genericMessage) {
      setLoading(true);
      let { start, end } = getSchedulesByDatesLimitDates(currentWeek);

      getSchedulesByDateLight(
        start,
        end,
        session.userType == 'assistant' || session.userType == 'operator'
          ? doctorId
          : session.id
      );
      // console.log('ENTRO GENERIC MESSAGE EFFECT ');
    }
  }, [appointmentsData.success.genericMessage]);

  useEffect(() => {
    setLoading(true);
    if (session && isProfessional(session.userType)) {
      getDoctorInfo(session.userType, session.id);
    }

    let { start, end } = getSchedulesByDatesLimitDates(currentWeek);

    getSchedulesByDateLight(
      start,
      end,
      session.userType == 'assistant' || session.userType == 'operator'
        ? doctorId
        : session.id
    );
    // console.log('ENTRO A CURRENTWEEK EFFECT ', currentWeek);
    // console.log('ESTE ES EL DOCTOR DATA ', doctorId);
  }, [currentWeek]);

  useEffect(() => {
    if (appointmentsData?.schedules) {
      setLoading(false);
    }
  }, [appointmentsData.schedules]);

  // useEffect(() => {
  //   console.log('este es el proficient $$$$$$$$$ ', proficients);
  // }, []);

  useEffect(() => {
    if (
      appointmentsData.scheduleCreated &&
      (session.userType == 'assistant' || session.userType == 'operator') &&
      isCreateAppointment &&
      appointmentsData.success.genericMessage == 'schedule creado con exito'
    ) {
      setLoading(true);
      console.log('ENTRO DIRIGIENDO ', appointmentsData.scheduleCreated);
      setIsCreateAppointment(false);
      appointmentsData.scheduleCreated.doctor = doctors.selectedDoctor;
      history.push({
        pathname: APPOINTMENT_LIGHT,
        state: { schedule: appointmentsData.scheduleCreated },
      });
      setLoading(false);
    }
  }, [appointmentsData.success.genericMessage]);
  // if (!session || !session.email || !isProfessional(session.userType)) {
  //   return <Redirect to={HOMEPAGE} />;
  // }

  const renderCalendar = () => {
    if (!showByWeek) {
      return <MonthCalendar
        currMonth={currentMonth}
        classes={classes}
        goToWeek={(week) =>
          setDateHandler({
            ...dateHandler,
            currentWeek: week,
            currentMonth: 0,
            showByWeek: true,
          })
        }
      />
    } else {
      return <DoctariCalendar
        currentWeek={currentWeek}
        creatingAvailability
        availability={availability}
        setAvailability={setAvailability}
        schedules={appointmentsData.schedules}
        deleteSchedule={deleteSchedule}
        selectedSchedule={selectedSchedule}
        setSelectedSchedule={setSelectedSchedule}
        isAssistant={session.userType == 'assistant'}
        isOperator={session.userType == 'operator'}
        isDoctor={session.userType == 'doctor'}
        selectedDoctor={doctors.selectedDoctor}
        slot={
          session.userType == 'doctor'
            ? session.slot
            : (session.userType == 'assistant' ||
              session.userType == 'operator') &&
              doctors.selectedDoctor
              ? doctors.selectedDoctor.specialty.duration.minutes
              : session.slot
          // session.slot
        }
      >
        {isEditable && (
          <Button
            variant="outlined"
            color="primary"
            style={{ width: '206px', marginRight: '0.5rem' }}
            onClick={() => {
              setAvailability({
                ...availability,
                isEditable: false,
                start: null,
                end: null,
              });
            }}
          >
            Cancelar
          </Button>
        )}
        <Button
          variant="outlined"
          color="primary"
          style={{ width: '206px' }}
          endIcon={isEditable ? <CheckCircle /> : <DateRange />}
          onClick={() => {
            if (isEditable) {
              setAvailability({
                ...availability,
                createModalOpen: true,
                openModalAvailability: true,
              });
            } else {
              setAvailability({
                ...availability,
                isEditable: true,
              });
            }
          }}
          disabled={(!start || !end) && isEditable}
        >
          {isEditable ? 'Confirmar' : 'Seleccionar rango'}
        </Button>
      </DoctariCalendar>
    }
  }

  const renderLoadingSpinner = () => {
    return <Grid
      item
      xs={12}
      md={12}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '100px',
      }}
    >
      <DoctariSpinner />
    </Grid>;
  }

  return (
    <>
      {appointmentsData.success.genericMessage ===
        'Schedule eliminado con exito' && (
          <Notification
            type="success"
            message={'Disponibilidad elimiada'}
            onCloseCallback={deleteMessages}
          />
        )}

      {appointmentsData.success.genericMessage ===
        'schedule creado con exito' && (
          <Notification
            type="success"
            message={'Disponibilidad añadida con éxito'}
            onCloseCallback={deleteMessages}
          />
        )}
      {appointmentsData.success.genericMessage ==
        'Appointment creado con exito' && (
          <Notification
            type="success"
            message={'Consulta creada con éxito'}
            onCloseCallback={deleteMessages}
          />
        )}
      {appointmentsData.error && (
        <Notification
          type="error"
          message={'Ha ocurrido un error al cargar los datos'}
          onCloseCallback={deleteMessages}
        />
      )}
      {/* {session.userType == 'assistant' && (
        <DoctariModal
          open={createModalOpen}
          setOpen={(val) =>
            setAvailability({
              ...availability,
              createModalOpen: val,
              openModalAvailability: val,
            })
          }
          title={'Seleccione acción'}
        >
          <SelectActionModal setAvailability={setAvailability} />
        </DoctariModal>
      )} */}
      {/* {(session.userType != 'assistant' || openModalAvailability) && ( */}
      <DoctariModal
        open={
          // session.userType != 'assistant'
          createModalOpen
          // : openModalAvailability
        }
        setOpen={(val) =>
          setAvailability({
            ...availability,
            createModalOpen: val,
            openModalAvailability: val,
          })
        }
        title={
          (session.userType == 'assistant' || session.userType == 'operator') &&
            !openModalAvailability
            ? 'Seleccione acción'
            : 'Marcar horas como disponibles'
        }
      >
        <CreateScheduleModal
          availabilityStart={availability.start}
          availabilityEnd={availability.end}
          createSchedule={createSchedule}
          classes={classes}
          addresses={
            doctors.selectedDoctor
              ? doctors.selectedDoctor.address
              : doctorsInfo?.address
          }
          token={session.accessToken}
          doctorId={
            session.userType == 'assistant' || session.userType == 'operator'
              ? doctorId
              : session.id
          }
          setAvailability={setAvailability}
          isAssistant={session.userType == 'assistant'}
          isOperator={session.userType == 'operator'}
          isDoctor={session.userType == 'doctor'}
          appointmentsData={appointmentsData}
          openModalAvailability={openModalAvailability}
          setIsCreateAppointment={setIsCreateAppointment}
          slot={
            // session.userType == 'doctor'
            // ?
            session.slot
            // : doctors.selectedDoctor.specialty.duration.minutes
          }
        />
      </DoctariModal>
      {/* )} */}

      <Grid
        container
        style={{ marginBottom: '5rem' }}
        className={classes.agendaContainer}
      >
        <Grid item xs={12} md={12} className={classes.changeView}>
          <span
            style={{
              marginRight: '0.5rem',
              cursor: 'pointer',
              fontWeight: showByWeek ? 700 : 200,
            }}
            onClick={() =>
              setDateHandler({
                ...dateHandler,
                showByWeek: true,
                currentMonth: 0,
              })
            }
          >{`Semana`}</span>
          <span
            style={{
              fontSize: '34px',
              fontWeight: 200,
            }}
          >
            |
          </span>
          <span
            style={{
              marginLeft: '0.5rem',
              cursor: 'pointer',
              fontWeight: showByWeek ? 200 : 700,
            }}
            onClick={() =>
              setDateHandler({
                ...dateHandler,
                showByWeek: false,
                currentWeek: 0,
              })
            }
          >{` Mes`}</span>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <DateControl
            showingByWeek={showByWeek}
            setCurrentWeek={(week) =>
              setDateHandler({ ...dateHandler, currentWeek: week })
            }
            currentWeek={currentWeek}
            setCurrentMonth={(month) =>
              setDateHandler({ ...dateHandler, currentMonth: month })
            }
            currentMonth={currentMonth}
            disabled={loading}
          />
        </Grid>

        {loading ?
          renderLoadingSpinner() :
          renderCalendar()
        }
      </Grid>
    </>
  );
}

const mapStateToProps = ({ session, user, appointments, doctors }) => {
  return {
    doctorsInfo: user.user,
    session,
    appointmentsData: appointments,
    user,
    doctors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  createSchedule: (body, isMultiple, token) =>
    dispatch({
      type: appointmentActionsTypes.CREATE_SCHEDULE,
      payload: { body, isMultiple, token },
    }),
  getDoctorInfo: (type, id) =>
    dispatch({
      type: userActionsTypes.GET_USER,
      payload: { type, id },
    }),
  getSchedulesByDateLight: (start, end, doctorId) =>
    dispatch({
      type: appointmentActionsTypes.GET_SCHEDULES_BY_DATE_LIGHT,
      payload: {
        start,
        end,
        doctorId,
      },
    }),
  deleteSchedule: (token, scheduleId, isMultiple) =>
    dispatch({
      type: appointmentActionsTypes.DELETE_SCHEDULE,
      payload: {
        token,
        scheduleId,
        isMultiple,
      },
    }),

  deleteMessages: () =>
    dispatch({
      type: userActionsTypes.DELETE_MESSAGES,
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(Agenda);

